<template>
  <div v-show="isActive">
    <slot :isActive="isActive"></slot>
  </div>
</template>

<script setup>
import { inject, onMounted, ref, watch } from 'vue';

// Props
const props = defineProps({
  name: { required: true },
  selected: { default: false }
});

// Inject dependencies from TabContainer
const registerTab = inject('registerTab');
// const activeTabName = inject('activeTabName'); // Inject the active tab name

const isActive = ref(false);

// Register the tab on mount
onMounted(() => {
  registerTab({
    name: props.name,
    isActive: isActive.value,
    selected: props.selected,
    setActive: (active) => {
      // This function is used to update the active state
      // console.log(`Setting ${props.name} active state to ${active}`);
      isActive.value = active;
    }
  });
});
</script>
